import React, { useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import logo from '../assets/logo.png';
import { prontuarioReset } from '../redux/features/prontuario/prontuarioSlice';
import { clearCache } from '../hooks/clearCache';
import { signOutMed } from '../store/modules/auth/doctor/actions';
import { signOutFunc } from '../store/modules/auth/funcionario/actions';
import { signOutPac } from '../store/modules/auth/patient/actions';
import history from '../services/history';
import AppFooter from '../components/AppFooter';

export default function Index() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(prontuarioReset());
    clearCache();
    dispatch(signOutMed());
    dispatch(signOutPac());
    dispatch(signOutFunc());
  }, [dispatch]);

  const handleClickICM = event => {
    event.preventDefault();
    window.location.target = '_blank';
    window.location.href = '//www.icm.com.br';
  };

  return (
    <div className="container-fluid px-2 px-sm-3">
      <div className="mx-auto mt-3 mt-sm-4 mt-md-5" style={{ maxWidth: 520 }}>
        <h3
          className="text-center text-success font-weight-bold"
          style={{ fontSize: 'clamp(1.75rem, 6vw, 2.2rem)' }}
        >
          Instituto do Coração de Marília
        </h3>
        <div className="text-center mb-2">
          <img src={logo} alt="logo" width={70} height={70} />
        </div>
        <Card className="mb-2">
          <Card.Body>
            <Card.Title>Paciente</Card.Title>
            <Button
              variant="outline-success"
              size="lg"
              block
              onClick={() => history.push('/plogin')}
            >
              Login Paciente
            </Button>
          </Card.Body>
        </Card>
        <Card className="mb-2">
          <Card.Body>
            <Card.Title>Hospital - Exames Internado e Amb.</Card.Title>
            <Button
              variant="outline-success"
              size="lg"
              block
              onClick={() => history.push('/externo')}
            >
              Login Hospital
            </Button>
          </Card.Body>
        </Card>
        <Card className="mb-2">
          <Card.Body>
            <Card.Title>Médicos do Corpo Clínico do ICM</Card.Title>
            <Button
              variant="outline-success"
              size="lg"
              block
              onClick={() => history.push('/mlogin')}
            >
              Login Médico
            </Button>
          </Card.Body>
        </Card>
        <Card className="mb-2">
          <Card.Body>
            <Card.Title>Funcionários do ICM</Card.Title>
            <Button
              variant="outline-success"
              size="lg"
              block
              onClick={() => history.push('/flogin')}
            >
              Login Funcionário
            </Button>
          </Card.Body>
        </Card>
        <Card className="mb-2">
          <Card.Body>
            <Button variant="outline-danger" block onClick={handleClickICM}>
              Sair
            </Button>
          </Card.Body>
        </Card>
        <AppFooter />
      </div>
    </div>
  );
}
